import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Webhook } from '../../../models';

import { Dropdown } from '@weezevent/nacre';

export const WebHooksListActions = React.memo(({ actions = [], handleAction, selectedItems }) => {
    const { t } = useTranslation();
    const _actions = Webhook.getRegisteredActions(actions);
    const isDisabled = React.useCallback(
        ({ condition, negate, key, bypass_item, conditionFunc }) => {
            if (!condition || bypass_item) return false;
            return selectedItems.some(it => {
                if (conditionFunc) return conditionFunc(it);
                return negate ? !it[key] : it[key];
            });
        },
        [selectedItems]
    );

    return _actions.map(({ action, label, delete_item, disabled }) => {
        return (
            <Dropdown.Item
                key={label}
                item={t(`sauron.webhook.bulk_actions.${label}`)}
                onClick={() => handleAction({ action })}
                disabled={isDisabled(disabled)}
                deleteItem={delete_item}
            />
        );
    });
});

WebHooksListActions.propTypes = {
    handleAction: PropTypes.func.isRequired,
    selectedItems: PropTypes.array
};

WebHooksListActions.defaultProps = {
    handleAction: () => {},
    selectedItems: []
};

export const WebHookActions = React.memo(({ webhook, actions = [], handleAction }) => {
    const { t } = useTranslation();
    const _actions = Webhook.getRegisteredActions(actions);
    const isDisabled = React.useCallback(
        ({ condition, negate, key, bypass_item, conditionFunc }) => {
            if (conditionFunc) return conditionFunc(webhook);
            if (!condition || bypass_item) return false;
            return Boolean(negate ? !webhook[key] : webhook[key]);
        },
        [webhook]
    );

    return _actions.map(({ action, method, label, delete_item, disabled }) => {
        return (
            <Dropdown.Item
                key={action}
                item={t(`sauron.webhook.${label}`)}
                onClick={() => handleAction(webhook, method)}
                deleteItem={delete_item}
                disabled={isDisabled(disabled)}
            />
        );
    });
});

WebHookActions.propTypes = {
    webhook: PropTypes.object,
    handleAction: PropTypes.func.isRequired,
    actions: PropTypes.array
};

WebHookActions.defaultProps = {
    handleAction: () => {},
    actions: []
};
